var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.emailSent)?_c('div',[_vm._v("Email Sending...")]):_vm._e(),(_vm.emailSent)?_c('div',[_vm._v("Email Already Sent")]):_vm._e(),(_vm.emailHasBeenSent)?_c('div',[_vm._v("Email Sent. Please close this window/tab!")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }